module.exports = __webpack_public_path__ + "img/btn_close.3b7f1620.png";